module.exports = __webpack_public_path__ + "static/media/main.b56b8b22.jpg";